import React, { useEffect, useState } from 'react';
import { Buffer } from 'buffer';
import { ReactSession } from "react-client-session";
import msg from './Tools/MsgUtils';
import CircleLoader from "react-spinners/CircleLoader";
import './css/BuscarEmpleado.css';
const server = process.env.REACT_APP_SERVER
function BuscarEmpleado({ setShowModal1,setColaborador,reg }) {
    const [empleados, setEmpleados] = useState([]);
    const [regional, setRegional] = useState(reg);
    const [nombre,setNombreBuscar] = useState('');
    const [loading, setLoading] = useState(false);
    const buscarEmpleado = () => {
        setLoading(true);
        fetch(`${server}/sqlComun/empleado/listaEmpleados`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                nombre: (nombre).toUpperCase(),
                regional: regional,
                estado: 'A',
                departamento: 0
            })
        })
            .then(res => res.json())
            .then(data => {
                if(data.ok){
                    setEmpleados(data.ok);
                }else{
                    msg.msgError(data.error);
                }
                setLoading(false);
            })
            .catch(err => msg.msgError(err));
    }
    const seleccionarEmpleado = (dato) => {
        setColaborador(dato);
        //setNombre(valor[0]);
        //setEmpleado(parseInt(valor[1]));
        setShowModal1(false);
        msg.msgCorrecto("Selecion correcta")
    }

    function blobToImage(blob, iden) {
        var imagen = Buffer.from(blob.data);
        imagen = imagen.toString('base64');
        var src = 'data:image/jpg;base64,' + imagen;
        return <img src={src} className='rounded-circle' id={iden} width='45px'></img>
    }
    useEffect(() => {
        if(regional===''){
            setRegional(ReactSession.get("regional"));
        }
    }, [regional]);
    return (
        <div className="">
            <div className="justify-content-center">
                <div className="card px-2 py-1 text-white bg-dark bg-gradient" id="form1">
                    <div className="container-fluid">
                        <div className="forms-inputs mb-4">
                            <span>Empleado</span>
                            <div className="input-group ">
                                <input type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Buscar Colaborador"
                                    value={nombre}
                                    onChange={(e)=>setNombreBuscar(e.target.value)}></input>
                                <a className='btn btn-sm btn-secondary bg-gradient'
                                    onClick={buscarEmpleado}
                                ><i className="fa-solid fa-magnifying-glass"></i> Buscar</a>
                            </div>
                        </div>
                    </div>
                    <div className="row d-none">
                        <div className="forms-inputs mb-4 px-2">
                            <span className='text-white text-uppercase'>Regional Actual</span>
                            <select className="form-select btn-info text-center" value={regional} onChange={(e) => {
                                setRegional(e.target.value);
                            }}>
                                <option value="990">Cochabamba</option>
                                <option value="991">Santa Cruz</option>
                            </select>
                        </div>
                    </div>
                    <div className='text-center mx-auto'>
                        <CircleLoader className='text-center mx-auto' color='#F95E10' loading={loading} size={200} />
                    </div>
                    {loading==false&&<div className="container-fluid">
                        <span>Encontrados</span>
                        <div className="overflow-auto container-fluid listaEmpleados">
                            <ul className="list-group list-group-sm" value='' >
                                {empleados.map((item) => {
                                    return <a className='list-group-item btn d-flex align-items-start btn-info w-100 bg-secondary bg-gradient'
                                        key={item.ID_EMPLEADO}
                                        id={item.NOMBREX + ':' + item.ID_EMPLEADO}
                                        onClick={()=>seleccionarEmpleado(item)}>
                                        {blobToImage(item.FOTO, item.NOMBREX + ':' + item.ID_EMPLEADO)}
                                        <div className='text-start'>
                                            <div className='px-4 fw-bold' id={item.NOMBREX + ':' + item.ID_EMPLEADO} style={{fontSize:'14px'}}>{item.NOMBREX}</div>
                                            <div className='px-4 text-light' id={item.NOMBREX + ':' + item.ID_EMPLEADO} style={{fontSize:'12px'}}>{item.CARGO}</div>
                                        </div>
                                        </a>
                                }
                                )}
                            </ul>
                        </div>
                    </div>}
                    <div className='container-fluid py-2 '>
                        <button type="button" className="btn btn-danger btn-sm text-center w-100" onClick={() => setShowModal1(false)}><i className='bi bi-x-octagon-fill px-2'></i>Salir</button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BuscarEmpleado
